import { render, staticRenderFns } from "./PickSubCategories.vue?vue&type=template&id=25a6579c&scoped=true&"
import script from "./PickSubCategories.vue?vue&type=script&lang=js&"
export * from "./PickSubCategories.vue?vue&type=script&lang=js&"
import style0 from "./PickSubCategories.vue?vue&type=style&index=0&id=25a6579c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6579c",
  null
  
)

export default component.exports